const LS_PREFIX = 'ATLASSIAN-STUDIO-';
export const OVERRIDES_KEY = `${LS_PREFIX}local-overrides`;
